import { render, staticRenderFns } from "./SocketCommHistoryDetail.vue?vue&type=template&id=d773abb6&scoped=true"
import script from "./SocketCommHistoryDetail.vue?vue&type=script&lang=js"
export * from "./SocketCommHistoryDetail.vue?vue&type=script&lang=js"
import style0 from "./SocketCommHistoryDetail.vue?vue&type=style&index=0&id=d773abb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d773abb6",
  null
  
)

export default component.exports